(() => {
  const root = document.querySelector('[data-nc-product]');
  if (root) {
    const main = document.querySelector('[id^="MainProduct-"]');
    const sticky = root.querySelector('[data-nc-sticky]');
    const add = root.querySelector('[data-nc-add]');
    const price = root.querySelector('[data-nc-sticky-price]');
    const change = root.querySelector('[data-nc-change]');
    const mainButton = () => main && main.querySelector('product-form button[type="submit"]');
    if (main && sticky && mainButton()) {
      let belowButton = false;
      const sync = () => {
        const button = mainButton();
        const drawer = document.querySelector('cart-drawer.active');
        const dialog = document.querySelector('dialog[open]');
        sticky.hidden = !belowButton || Boolean(drawer || dialog);
        add.disabled = !button || button.disabled || button.getAttribute('aria-disabled') === 'true';
        const visiblePrice = main.querySelector('.price--on-sale .price-item--sale') || main.querySelector('.price-item--regular');
        if (visiblePrice) price.textContent = visiblePrice.textContent.trim();
        if (button) add.textContent = button.querySelector('span')?.textContent.trim() || button.textContent.trim();
      };
      new IntersectionObserver(entries => {
        belowButton = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
        sync();
      }).observe(mainButton());
      new MutationObserver(sync).observe(main, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
      const cart = document.querySelector('cart-drawer');
      if (cart) new MutationObserver(sync).observe(cart,{attributes:true,attributeFilter:['class']});
      document.addEventListener('nc-popup-change',sync);
      add.addEventListener('click',() => {
        const button = mainButton();
        if (button && !add.disabled) button.click();
        sync();
      });
      change.href = '#' + main.id;
      change.addEventListener('click',event => {
        event.preventDefault();
        const picker = main.querySelector('variant-selects,variant-radios') || main;
        picker.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        picker.querySelector('input,select,button')?.focus({preventScroll:true});
      });
      sync();
    }
  }
  const popup = document.querySelector('[data-nc-popup]');
  if (!popup || typeof popup.showModal !== 'function') return;
  const key = 'nolera-signup-dismissed';
  const notify = () => document.dispatchEvent(new Event('nc-popup-change'));
  const open = () => {
    if (popup.open || document.querySelector('cart-drawer.active,dialog[open]')) return;
    popup.showModal();
    notify();
  };
  const close = () => {
    popup.close();
    try { localStorage.setItem(key,String(Date.now())); } catch {}
    notify();
  };
  popup.querySelector('[data-nc-signup-close]').addEventListener('click',close);
  popup.addEventListener('cancel',event => {event.preventDefault();close();});
  popup.addEventListener('click',event => {if(event.target===popup){const r=popup.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
  document.querySelectorAll('[data-nc-signup-open]').forEach(button=>button.addEventListener('click',open));
  let eligible = true;
  try {eligible = Date.now()-Number(localStorage.getItem(key)||0)>7*24*60*60*1000;} catch {}
  if(eligible && !location.pathname.includes('/cart') && !location.pathname.includes('/policies')) setTimeout(open,Number(popup.dataset.delay||20)*1000);
})();
